<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline pl-2 pa-1">
                    {{ $t("settings.createTermsAndConditions.uploadNew") }}
                  </div>
                </div>
              </v-card-title>
                <v-flex xs12 mt-3 grow class="full-width pa-4 pt-6 v-doc-form">
                  <upload-file
                    class="docs"
                    @change="model.file = $event"
                    :documentName="$t('settings.createTermsAndConditions.termsAndConditions')"
                  />
                <v-btn
                  :loading="loading"
                  block
                  @click="createTerms"
                  color="secondary"
                  dark
                  >{{ $t("settings.createTermsAndConditions.upload") }}</v-btn
                >
            </v-flex>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<style>
.docs {
  margin-bottom: 3px;
    text-align:center;
}
.v-doc-form{
    align-items: center;
    justify-content: center;
    display:grid;
}
</style>

<script>
import axios from "axios";
import UploadFile from "@/components/widgets/UploadFile.vue";

export default {
  title() {
    return this.$t("settings.createTermsAndConditions.title");
  },
  components: {
    UploadFile,
  },
  data: () => ({
    file: null,
    loading: false,
    model: {
        file:null,
    },
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("settings.createTermsAndConditions.invalidEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("settings.createTermsAndConditions.invalidLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) || this.$t("settings.createTermsAndConditions.passwordLength"),

        required: (v) => !!v || this.$t("common.required"),
      };
    },
  },
  mounted() {},

  methods: {
    createTerms() {
      console.log(this.file);
        this.loading = true;
        const formData = new FormData();
        formData.append("file", this.model.file);
        this.axios
          .post(this.api.ACTIONS.TERMS, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("settings.createTermsAndConditions.termCreated"), "green");
            this.$router.push("/terms_and_conditions");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("settings.createTermsAndConditions.checkYourInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      console.log(this.file);
      // }
    },
  },
};
</script>
